import HttpService from '../common/http/HttpService';
import MinuteValuesToggleEndpoint from './minuteValuesToggleEndpoint';

async function getMinuteValuesToggle(systemId, componentType) {
  return HttpService.post(
    MinuteValuesToggleEndpoint.GET_MINUTE_VALUES_TOGGLE,
    { systemId, componentType },
  );
}

async function setMinuteValuesToggle(systemId, componentType, isSelected) {
  await HttpService.post(
    MinuteValuesToggleEndpoint.SET_MINUTE_VALUES_TOGGLE,
    { systemId, componentType, isSelected },
  );
}

const MinuteValuesToggleService = {
  getMinuteValuesToggle,
  setMinuteValuesToggle,
};

export default MinuteValuesToggleService;
